export const GET_ACCOUNTS_REQUEST = 'GET_ACCOUNTS_REQUEST';
export const GET_CLIENT_ACCOUNTS_TIME_REQUEST = 'GET_CLIENT_ACCOUNTS_TIME_REQUEST';
export const GET_ACCOUNT_BILLING_ENTITIES_REQUEST = 'GET_ACCOUNT_BILLING_ENTITIES_REQUEST';
export const GET_ACCOUNT_REQUEST = 'GET_ACCOUNT_REQUEST';
export const GET_ACCOUNT_PROJECTS_REQUEST = 'GET_ACCOUNT_PROJECTS_REQUEST';
export const GET_ACCOUNT_GROUPS_REQUEST = 'GET_ACCOUNT_GROUPS_REQUEST';
export const CREATE_ACCOUNT_REQUEST = 'CREATE_ACCOUNT_REQUEST';
export const UPDATE_ACCOUNT_REQUEST = 'UPDATE_ACCOUNT_REQUEST';
export const ACTIVATE_ACCOUNT_REQUEST = 'ACTIVATE_ACCOUNT_REQUEST';
export const DEACTIVATE_ACCOUNT_REQUEST = 'DEACTIVATE_ACCOUNT_REQUEST';
export const GET_ACCOUNT_MEMBERS_REQUEST = 'GET_ACCOUNT_MEMBERS_REQUEST';
export const ADD_ACCOUNT_MEMBERS_REQUEST = 'ADD_ACCOUNT_MEMBERS_REQUEST';
export const REMOVE_ACCOUNT_MEMBERS_REQUEST = 'REMOVE_ACCOUNT_MEMBERS_REQUEST';
export const DELETE_ACCOUNT_REQUEST = 'DELETE_ACCOUNT_REQUEST';
export const RESTORE_ACCOUNT_REQUEST = 'RESTORE_ACCOUNT_REQUEST';

export const getClientAccountsTime = (clientId, callback) => ({
    type: GET_CLIENT_ACCOUNTS_TIME_REQUEST,
    payload: { clientId, callback },
});

export const getAccounts = (start, limit, client, pinned, callback) => ({
  type: GET_ACCOUNTS_REQUEST,
  payload: { start, limit, client, pinned, callback },
});

export const getAccountBillingEntities = (callback) => ({
  type: GET_ACCOUNT_BILLING_ENTITIES_REQUEST,
  payload: { callback },
});

export const getAccount = (accountId, callback) => ({
    type: GET_ACCOUNT_REQUEST,
    payload: { accountId, callback }
});

export const getAccountProjects = (accountId, state = '', callback) => ({
    type: GET_ACCOUNT_PROJECTS_REQUEST,
    payload: { accountId, state, callback }
});

export const getAccountGroups = (accountId, callback) => ({
    type: GET_ACCOUNT_GROUPS_REQUEST,
    payload: { accountId, callback }
});

export const createAccount = (clientId, accountData, callback) => ({
    type: CREATE_ACCOUNT_REQUEST,
    payload: { clientId, accountData, callback },
});

export const updateAccount = (accountId, accountData, callback) => ({
    type: UPDATE_ACCOUNT_REQUEST,
    payload: { accountId, accountData, callback },
});

export const activateAccount = (accountId, callback) => ({
    type: ACTIVATE_ACCOUNT_REQUEST,
    payload: { accountId, callback },
});

export const deactivateAccount = (accountId, callback) => ({
    type: DEACTIVATE_ACCOUNT_REQUEST,
    payload: { accountId, callback },
});

export const getAccountMembers = (accountId, callback) => ({
  type: GET_ACCOUNT_MEMBERS_REQUEST,
  payload: { accountId, callback },
});

export const addAccountMembers = (accountId, accountMembers, callback) => ({
    type: ADD_ACCOUNT_MEMBERS_REQUEST,
    payload: { accountId, accountMembers, callback },
});

export const removeAccountMembers = (accountId, accountMembers, callback) => ({
    type: REMOVE_ACCOUNT_MEMBERS_REQUEST,
    payload: { accountId, accountMembers, callback },
});

export const deleteAccount = (accountId, callback) => ({
    type: DELETE_ACCOUNT_REQUEST,
    payload: { accountId, callback },
});

export const restoreAccount = (accountId, callback) => ({
    type: RESTORE_ACCOUNT_REQUEST,
    payload: { accountId, callback },
});
